"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BiMap = void 0;
class BiMap {
    constructor(s) {
        this.revMap = new Map();
        if (s === undefined) {
            this.map = new Map();
        }
        else {
            this.map = new Map(s);
            this.map.forEach((v, k) => {
                this.revMap.set(v, k);
            });
        }
    }
    set(k, v) {
        const currV = this.map.get(k);
        if (currV != undefined) {
            this.revMap.delete(currV);
        }
        this.revMap.set(v, k);
        this.map.set(k, v);
    }
    deleteKey(k) {
        const v = this.map.get(k);
        if (v != undefined) {
            this.revMap.delete(v);
        }
        this.map.delete(k);
    }
    deleteValue(v) {
        const k = this.revMap.get(v);
        if (k != undefined) {
            this.map.delete(k);
        }
        this.revMap.delete(v);
    }
    getValue(key) {
        return this.map.get(key);
    }
    getKey(value) {
        return this.revMap.get(value);
    }
    clear() {
        this.map.clear();
        this.revMap.clear();
    }
    getKeys() {
        return Array.from(this.map.keys());
    }
    getValues() {
        return Array.from(this.map.values());
    }
    size() {
        return this.map.size;
    }
    hasKey(k) {
        return this.map.has(k);
    }
    hasValue(v) {
        return this.revMap.has(v);
    }
}
exports.BiMap = BiMap;
